// import React, { Fragment, useState, useContext } from 'react'

// import bancolombia from '../assets/bancolombia.png'
// import pse from '../assets/pse.png'
// import nequi from '../assets/nequi_card.png'
// import credit_card from '../assets/credit_card_international.png'
// import credit_card_international from '../assets/credit_card_international.png'

// import efecty from '../assets/efecty.png'
// import boton_bancolombia from '../assets/boton_bancolombia.png'
// import dale from '../assets/dale.png'
// import CUSD from '../assets/celo.png'
// import bc_icon from '../assets/bc-card.png'
// import corresponsal_bancolombia from '../assets/bancolombia_corresponsal.png'
// import BTC from '../assets/bitcoin.png'
// import cobru from '../assets/cobru_icon.png'
// import bancolombia_qr_icon from '../assets/qr_bancolombia.png'
// import bancolombia_transfer_icon from '../assets/bancolombia_transfer.png'
// import usdt_icon from '../assets/usdt.png'
// import baloto_icon from '../assets/baloto.png'
// import DAI_icon from '../assets/dai.png'
// import dash_icon from '../assets/dash.png'
// import bch_icon from '../assets/bch.png'
// import daviplata_icon from '../assets/daviplata.png'
// import tpaga_icon from '../assets/tpaga.png'
// import paga_hoy_icon_  from '../assets/icons/pagahoy-icon.png'
// import safetypay_icon  from '../assets/safetypay.png'
// import { MainContext } from '../contexts/MainContext'

// export const Carousel = ({ paymentsMethodArray, onClickItem = () => { }, paymentsMethod, currentPaymentMethod }) => {
//     //const isEzy = window?.location?.hostname === 'link.ezytransfer.co' ? true : false
//     //const isPagaHoy = window?.location?.hostname === 'link.pagahoy.com' ? true : false
//     const { isEzy, isPagaHoy, isTucanPay } = useContext(MainContext);
//     const [hoveredIndex, setHoveredIndex] = useState(false);

//     const ImageBank = (id) => {
//         let img = null;
//         switch (id) {
//             case 'credit_card':
//                 img = credit_card;
//                 break;
//             case 'NEQUI':
//                 img = nequi;
//                 break;
//             case 'corresponsal_bancolombia':
//                 img = corresponsal_bancolombia;
//                 break;
//             case 'bancolombia_transfer':
//                 img = bancolombia_transfer_icon
//                 break;
//             case 'bancolombiapay':
//                 img = bc_icon
//                 break;
//             case 'pse':
//                 img = pse;
//                 break;
//             case 'dale':
//                 img = dale;
//                 break;
//             case 'efecty':
//                 img = efecty;
//                 break;
//             case 'BTC':
//                 img = BTC;
//                 break;
//             case 'CUSD':
//                 img = CUSD;
//                 break;
//             case 'cobru':
//                 img = isPagaHoy ? paga_hoy_icon_ :cobru;
//                 break;
//             case 'bancolombia_qr':
//                 img = bancolombia_qr_icon
//                 break;
//             case 'USDT':
//                 img = usdt_icon
//                 break;
//             case 'DAI':
//                 img = DAI_icon;
//                 break;
//             case 'baloto':
//                 img = baloto_icon;
//                 break;
//             case 'DASH':
//                 img = dash_icon;
//                 break;
//             case 'BCH':
//                 img = bch_icon;
//                 break;
//             case 'credit_card_international':
//                 img = credit_card_international;
//                 break;
//             case 'daviplata':
//                 img = daviplata_icon;
//                 break;
//             case 'tpaga':
//                 img = tpaga_icon;
//                 break;
//             case 'safetypay':
//                 img = safetypay_icon;
//                 break;
//             default:
//                 img = null;
//                 break;
//         }
//         return img;
//     };
//     const getPadding = (method) => {
//         switch (method) {
//             case 'bancolombia_transfer':
//             case 'corresponsal_bancolombia':
//                 return { padding: 0 }
//                 break;
//             case 'DASH':
//             case 'bancolombiapay':
//                 return { padding: 15 }
//                 break;
//             default:
//                 return null
//                 break;
//         }

//     }

//     const style = {
//         hover: {
//             "borderWidth": 2,
//             "borderColor": isEzy ? '#2e86c1' : isPagaHoy ? '#f84365' : isTucanPay? '#f39731': '#1cce28',
//             "borderStyle": "solid"
//         }
//     }
//     return (
//         <div className="paymentOptions">
//             {paymentsMethod && paymentsMethodArray.map((item, i) => {
//                 if (item && Object.keys(item)[0] === 'credit_card_international') {
//                     return null
//                 }
//                 if (item && Object.keys(item)[0] === 'transfer') {
//                     return null
//                 }
//                 return (
//                     <Fragment key={`item-${i}`}>
//                         <button
//                             onClick={() => onClickItem(item)}
//                             className={`bg-white flex items-center justify-center paymentOptionsx ${item === currentPaymentMethod
//                                 ? isEzy
//                                     ? "paymentOptionBorderEzy"
//                                     : isPagaHoy
//                                         ? "paymentOptionBorderPagaHoy"
//                                     : isTucanPay ?
//                                     'paymentOptionBorderTucanPay'
//                                         : "paymentOptionBorder"
//                                 : ""
//                                 }`}
//                             onMouseEnter={() => setHoveredIndex(i)} // Guardar el índice del botón actual
//                             onMouseLeave={() => setHoveredIndex(null)} // Eliminar el índice cuando no está hovereado
//                             style={{
//                                 ...getPadding(Object.keys(item)[0]),
//                                 ...(hoveredIndex === i && item !== currentPaymentMethod && style?.hover) // Aplicar el estilo solo al botón hovereado
//                             }}
//                         >
//                             <img
//                                 className={`${item?.name?.credit_card ? "imagen-data_" : ""
//                                     } imagen-data`}
//                                 alt={Object.keys(item)[0]}
//                                 src={ImageBank(Object.keys(item)[0])}
//                             />
//                         </button>
//                         { }
//                     </Fragment>
//                 );
//             })
//             }

//         </div>
//     )
// }
import React, { Fragment, useState, useContext, useRef, useEffect, useLayoutEffect, useCallback, useMemo } from 'react'


import bancolombia from '../assets/bancolombia.png'
import pse from '../assets/pse.png'
import nequi from '../assets/nequi_card.png'
import credit_card from '../assets/credit_card_international.png'
import credit_card_international from '../assets/credit_card_international.png'

import efecty from '../assets/efecty.png'
import boton_bancolombia from '../assets/boton_bancolombia.png'
import dale from '../assets/dale.png'
import CUSD from '../assets/celo.png'
import bc_icon from '../assets/bc-card.png'
import corresponsal_bancolombia from '../assets/bancolombia_corresponsal.png'
import BTC from '../assets/bitcoin.png'
import cobru from '../assets/cobru_icon.png'
import bancolombia_qr_icon from '../assets/qr_bancolombia.png'
import bancolombia_transfer_icon from '../assets/bancolombia_transfer.png'
import usdt_icon from '../assets/usdt.png'
import baloto_icon from '../assets/baloto.png'
import DAI_icon from '../assets/dai.png'
import dash_icon from '../assets/dash.png'
import bch_icon from '../assets/bch.png'
import daviplata_icon from '../assets/daviplata.png'
import tpaga_icon from '../assets/tpaga.png'
import paga_hoy_icon_ from '../assets/icons/pagahoy-icon.png'
import safetypay_icon from '../assets/safetypay.png'
import breb_icon from '../assets/bre-b.png'
import tengoMark from '../assets/icons/tengo-mark.svg'
import { MainContext } from '../contexts/MainContext'// ... tus imports de imágenes

export const Carousel = ({ paymentsMethodArray, onClickItem = () => { }, paymentsMethod, currentPaymentMethod, accentColor = null }) => {
  const { isEzy, isPagaHoy, isTucanPay, getBrandAccentColor, isBitppi, isTengo } = useContext(MainContext);
  const [hoveredIndex, setHoveredIndex] = useState(false);

  const containerRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);
  const brandAccent = (() => {
    if (accentColor) return accentColor;
    if (isEzy) return '#2e86c1';
    if (isPagaHoy) return '#f84365';
    if (isTucanPay) return '#f39731';
    if (isBitppi) return '#a70082';
    if (isTengo) return '#6d00d6';
    try {
      return getBrandAccentColor ? getBrandAccentColor() : '#1cce28';
    } catch {
      return '#1cce28';
    }
  })();

  const visibleMethodItems = useMemo(() => {
    if (!paymentsMethod || !Array.isArray(paymentsMethodArray)) return [];
    return paymentsMethodArray.filter((item) => {
      const key = item && Object.keys(item)[0];
      if (!key) return false;
      if (key === 'credit_card_international') return false;
      if (key === 'transfer') return false;
      return true;
    });
  }, [paymentsMethod, paymentsMethodArray]);

  const showCarouselArrows = visibleMethodItems.length > 3;

  const updateScrollEdges = useCallback(() => {
    const el = containerRef.current;
    if (!el) {
      setCanScrollLeft(false);
      setCanScrollRight(false);
      return;
    }
    const max = el.scrollWidth - el.clientWidth;
    if (max <= 1) {
      setCanScrollLeft(false);
      setCanScrollRight(false);
      return;
    }
    // tolerancia por subpixels
    setCanScrollLeft(el.scrollLeft > 1);
    setCanScrollRight(el.scrollLeft < max - 1);
  }, []);

  const scrollByDirection = (dir) => {
    const el = containerRef.current;
    if (!el) return;
    const amount = Math.max(160, Math.floor(el.clientWidth * 0.85));
    el.scrollBy({ left: dir === "left" ? -amount : amount, behavior: "smooth" });
    // actualizar bordes tras animación
    window.setTimeout(updateScrollEdges, 400);
  };

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    if (!showCarouselArrows) return;

    const handleWheel = (e) => {
      if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
        // si el scroll es vertical → convertirlo en horizontal
        e.preventDefault();
        container.scrollBy({
          left: e.deltaY, // desplazamiento horizontal
          behavior: "smooth" // animación suave
        });
        window.setTimeout(updateScrollEdges, 0);
      }
    };

    container.addEventListener("wheel", handleWheel, { passive: false });
    return () => container.removeEventListener("wheel", handleWheel);
  }, [showCarouselArrows]);

  useLayoutEffect(() => {
    updateScrollEdges();
    const el = containerRef.current;
    if (!el) return;

    const onResize = () => updateScrollEdges();
    window.addEventListener("resize", onResize);

    let ro;
    if (typeof ResizeObserver !== "undefined") {
      ro = new ResizeObserver(() => updateScrollEdges());
      ro.observe(el);
    }

    return () => {
      window.removeEventListener("resize", onResize);
      if (ro) ro.disconnect();
    };
  }, [paymentsMethodArray, paymentsMethod, showCarouselArrows, updateScrollEdges]);

  const ImageBank = (id) => {
    switch (id) {
      case 'credit_card': return credit_card;
      case 'NEQUI': return nequi;
      case 'corresponsal_bancolombia': return corresponsal_bancolombia;
      case 'bancolombia_transfer': return bancolombia_transfer_icon;
      case 'bancolombiapay': return bc_icon;
      case 'pse': return pse;
      case 'dale': return dale;
      case 'efecty': return efecty;
      case 'BTC': return BTC;
      case 'CUSD': return CUSD;
      case 'cobru': return isTengo ? tengoMark : isPagaHoy ? paga_hoy_icon_ : cobru;
      case 'bancolombia_qr': return bancolombia_qr_icon;
      case 'USDT': return usdt_icon;
      case 'DAI': return DAI_icon;
      case 'baloto': return baloto_icon;
      case 'DASH': return dash_icon;
      case 'BCH': return bch_icon;
      case 'credit_card_international': return credit_card_international;
      case 'daviplata': return daviplata_icon;
      case 'tpaga': return tpaga_icon;
      case 'safetypay': return safetypay_icon;
      case 'breb': return breb_icon;
      default: return null;
    }
  };

  const getPadding = (method) => {
    switch (method) {
      case 'bancolombia_transfer':
      case 'corresponsal_bancolombia':
        return { padding: 0 };
      case 'DASH':
      case 'bancolombiapay':
        return { padding: 15 };
      default:
        return null;
    }
  };

  const style = {
    hover: {
      borderWidth: 2,
      borderColor: brandAccent,
      borderStyle: "solid"
    }
  };

  const Chevron = ({ dir }) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d={dir === "left" ? "M15.5 5.5L8.5 12l7 6.5" : "M8.5 5.5L15.5 12l-7 6.5"}
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  const renderMethodButton = (item, i) => {
    const key = item && Object.keys(item)[0];
    return (
      <Fragment key={`item-${key || i}`}>
        <button
          onClick={() => onClickItem(item)}
          className={`bg-white flex items-center justify-center paymentOptionsx ${item === currentPaymentMethod
            ? isEzy
              ? "paymentOptionBorderEzy"
              : isPagaHoy
                ? "paymentOptionBorderPagaHoy"
                : isTucanPay
                  ? 'paymentOptionBorderTucanPay'
                  : isTengo
                    ? 'paymentOptionBorderTengo'
                  : isBitppi
                    ? 'paymentOptionBorderBitppi'
                    : "paymentOptionBorder"
            : ""
            }`}
          onMouseEnter={() => setHoveredIndex(i)}
          onMouseLeave={() => setHoveredIndex(null)}
          style={{
            ...getPadding(key),
            ...(accentColor && item === currentPaymentMethod ? { borderColor: brandAccent } : {}),
            ...(hoveredIndex === i && item !== currentPaymentMethod && style?.hover)
          }}
        >
          <img
            className={`${item?.name?.credit_card ? "imagen-data_" : ""} imagen-data`}
            alt={key}
            src={ImageBank(key)}
          />
        </button>
      </Fragment>
    );
  };

  if (!showCarouselArrows) {
    return (
      <div
        className="paymentOptions paymentOptions--hide-scrollbar w-full"
        ref={containerRef}
        onScroll={updateScrollEdges}
      >
        {visibleMethodItems.map((item, i) => renderMethodButton(item, i))}
      </div>
    );
  }

  return (
    <div className="flex w-full min-w-0 items-center gap-1.5 sm:gap-2">
      <button
        type="button"
        aria-label="Anterior"
        onClick={() => scrollByDirection("left")}
        disabled={!canScrollLeft}
        className={[
          "shrink-0",
          "inline-flex h-8 w-8 items-center justify-center",
          "rounded-full border border-black/5 bg-white/90 text-gray-800 shadow-sm",
          "transition will-change-transform",
          canScrollLeft ? "hover:scale-105 active:scale-95" : "cursor-not-allowed opacity-30",
        ].join(" ")}
        style={{ color: brandAccent }}
        title="Anterior"
      >
        <Chevron dir="left" />
      </button>

      <div
        className="paymentOptions paymentOptions--hide-scrollbar min-w-0 flex-1"
        ref={containerRef}
        onScroll={updateScrollEdges}
      >
        {visibleMethodItems.map((item, i) => renderMethodButton(item, i))}
      </div>

      <button
        type="button"
        aria-label="Siguiente"
        onClick={() => scrollByDirection("right")}
        disabled={!canScrollRight}
        className={[
          "shrink-0",
          "inline-flex h-8 w-8 items-center justify-center",
          "rounded-full border border-black/5 bg-white/90 text-gray-800 shadow-sm",
          "transition will-change-transform",
          canScrollRight ? "hover:scale-105 active:scale-95" : "cursor-not-allowed opacity-30",
        ].join(" ")}
        style={{ color: brandAccent }}
        title="Siguiente"
      >
        <Chevron dir="right" />
      </button>
    </div>
  );
};
